import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { TypedChanges } from '@platform-frontend/util';
import { ToggleState } from '../toggle-state';

@Component({
  selector: 'yat-toggle',
  templateUrl: './toggle.component.html',
  styleUrls: ['./toggle.component.scss']
})
export class ToggleComponent implements OnChanges {
  @Input()
  disabled: boolean = false;

  @Input()
  toggleSelect: boolean = false;

  @Input()
  variant: 'toggle' | 'tabs' = 'toggle';

  @Input()
  leftLabel: string = '';

  @Input()
  rightLabel: string = '';

  @Input()
  selectedValue: ToggleState = 'left';

  @Output()
  toggleChanged: EventEmitter<ToggleState> = new EventEmitter<ToggleState>();

  checked: boolean = false;

  ngOnChanges(changes: TypedChanges<ToggleComponent>): void {
    if (changes.selectedValue) {
      this.updateValues(this.selectedValue === 'right');
    }
  }

  onToggleChange(event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    this.updateValues(checked);
  }

  onTabSelect(value: ToggleState): void {
    const checked = value === 'right';
    if (!this.disabled && checked !== this.checked) {
      this.updateValues(value === 'right');
    }
  }

  private updateValues(checked: boolean): void {
    this.toggleChanged.emit(checked ? 'right' : 'left');
    this.checked = checked;
  }
}
